export default {
  getClientName: state => state.clientName,
}
